export const CURRENCY_SELECTOR = 'CURRENCY_SELECTOR';

export default {
  name: CURRENCY_SELECTOR,
  rollOut: 0,
};
